var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionIconList',{attrs:{"align":"center","items":_vm.reasons,"itemsPerLine":3,"size":null,"title":_vm.$t('headline')}})
}
var staticRenderFns = []

export { render, staticRenderFns }